import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { SelectAsset } from '../../services/forms/SelectAsset';

const AssetComponent = ({ field, value, onChange, disabledField }) => {
  const [itemValue, setValue] = useState(value);

  const onSelect = useCallback(
    (selectedValue) => {
      setValue(selectedValue);
      onChange(selectedValue);
    },
    [onChange],
  );

  return (
    <>
      <SelectAsset
        idAssetType={field.typeSelected}
        selectedAsset={itemValue}
        onChange={onSelect}
        disabledField={disabledField}
      />
    </>
  );
};

export default AssetComponent;

AssetComponent.propTypes = {
  field: PropTypes.object,
  value: PropTypes.object,
  onChange: PropTypes.object,
  disabledField: PropTypes.bool,
};
